import { FormSubmissionSourceType } from '@commenda/prisma';
import { useApiScope } from '../../scope';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';
import { IFormSubmission } from './types';

type LatestSubmissionForSourceResponse = {
  formSubmission: IFormSubmission | null;
};

export const useLatestSubmissionForSource = (
  sourceEntityType: FormSubmissionSourceType,
  sourceEntityId: string | null | undefined
) => {
  const { shareToken } = useApiScope();

  const url = sourceEntityId
    ? `${BASE_URL}/latest-for-source?sourceEntityType=${encodeURIComponent(
        sourceEntityType
      )}&sourceEntityId=${encodeURIComponent(sourceEntityId)}`
    : null;

  const { data, error, isLoading, mutate } =
    useSWR<LatestSubmissionForSourceResponse>(
      url,
      SWRFetcher({
        method: 'GET',
        shareToken,
      })
    );

  return {
    data,
    error,
    isLoading,
    mutate,
    submission: data?.formSubmission ?? null,
  };
};
